<template>
  <div v-if="loading" class="preview-multi-select">
    <b>CFOP:</b> <span>Selecione</span>
  </div>
  <MultiSelect
    v-else
    label="CFOP"
    :campos="cfops"
    :filtro="filtro"
    :filtro_id="filtro.filtro"
    :path="path"
    @atualizar="atualizar"
  />
</template>
<script>
import MultiSelect from '../../components/MultiSelect.vue';
export default {
  props: {
    filtro: {
      type: Object,
      required: true,
    },
    path: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      cfops: [],
      loading: true
    }
  },
  components: {
    MultiSelect
  },
  methods: {
    atualizar(selecionados) {
      this.$aplicaFiltroEmURL(this.filtro.filtro, selecionados, this.path);
      this.$store.commit('addFiltro', this.filtro);
      this.$store.commit('addFiltroAplicado', {
        filtro: this.filtro.filtro,
        valor: selecionados
      });
    },
  },
  mounted() {
    this.$api.get('/cfops').then(response => {
      const cfops = response.data;
      this.cfops = cfops.map(cfop => ({
        id: cfop.id,
        name: cfop.codigo
      }));

      this.loading = false;
    })
  }
}
</script>
